export default {"src":"/_next/static/image/src/assets/images/results_not_found.4622e09f6820aeb45c2731391d651a9f.svg","height":144,"width":144};